import { Country } from 'services/api/constants'
import { getTimeZonedDateNow } from 'services/dates'

export function validateDateLaterThenNow(date: Date, country: Country, compareTime?: boolean): boolean {
    const now = getTimeZonedDateNow(country)
    if (compareTime) {
        return now.getTime() <= date.getTime()
    } else {
        //only compare the date
        const selectWithoutTime = new Date(date.getFullYear(), date.getMonth(), date.getDate())
        const nowWithoutTime = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        return nowWithoutTime <= selectWithoutTime
    }
}

/**
 * @description check if string is parsable by JSON.parse into object
 * @param str JSON string
 * @returns boolean
 */
export const isJSONParsableObject = (str: string): boolean => {
    try {
        const parsed = JSON.parse(str)
        return typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)
    } catch (e) {
        return false
    }
}

export const safeParseJSON = (value: string) => {
    try {
        return JSON.parse(value)
    } catch (error) {
        return null
    }
}
